<main *ngIf="choice === 'image'" class="addition">
  <mat-form-field appearance=outline id=link>
    <mat-label>Ссылка на картинку</mat-label>
    <input matInput placeholder="https://example.org/example.jpeg" #imgLink>
  </mat-form-field>
  <button mat-stroked-button (click)="add_image(imgLink.value)">Добавить</button>
</main>
<main *ngIf="choice === 'link'" class="addition">
  <mat-form-field appearance=outline id=title>
    <mat-label>Заголовок ссылки</mat-label>
    <input matInput placeholder="Перейти в нашу группу ВК" #title>
  </mat-form-field>
  <mat-form-field appearance=outline id=ref>
    <mat-label>Ссылка на страницу</mat-label>
    <input matInput placeholder="https://vk.com/almastu_club" #pageLink>
  </mat-form-field>
  <button mat-stroked-button (click)="add_link(title.value, pageLink.value)">Добавить</button>
</main>
